<div class="width-100">
  <esc-report-viewer
    [columns]="columns"
    [listData]="listData"
    [listLength]="listLength"
    [loading]="loading"
    [filterNumber]="filterNumber"
    [currentFilters]="currentFilters"
    [pageSize]="pageSize"
    [pageSizeOptions]="[10, 15, 20]"
    [page]="page"
    (onDownloadEvent)="downloadReport()"
    (onOpenFilterEvent)="openFilter()"
    (onPageChangeEvent)="onPageChange($event)"
    (onRefreshEvent)="refresh()"
    moduleCode="SBTR"
  >
  </esc-report-viewer>
</div>
